import Hammer from 'hammerjs'

$.fn.MobileCard = function() {
  let self = $(this).BlockElement()

  if (self.data('mobile-card')) {
    return self.data('mobile-card')
  }

  self.expanded = false
  self.position = undefined
  self.hammer = undefined
  self.touchX = undefined
  self.touchY = undefined
  self.scroller = self.ScrollEvents()
  self.has_reached_bottom = false

  self.close_content = function() {
    self.expanded = false
    let targetHeight = $('.navigator__viewport').height()
    self.animate({'scrollTop' : 0}, 350, 'easeInOutQuart')
    self.find('.navigator-item__card-wrapper').animate({
      height: targetHeight + 'px',
    }, 450, 'easeInOutQuart', function() {
      self.removeModifier('scroller')
      self.find('.navigator-item__card-wrapper').css('height', '100%')
      self.find('.navigator-item__gallery-wrapper').css('height', '')
    })
    $('.navigator').removeClass('navigator--mobile-expanded')
    self.remove_expanded_events()
  }

  self.expand_content = function() {
    if ($.mlmi.mobile.isMobile) {
      self.expanded = true
      let currentGalleryHeight = self.find('.navigator-item__gallery-wrapper').height(),
      targetGalleryHeight = $(window).width() * 4 / 5
      self.find('.navigator-item__gallery-wrapper').css('height', targetGalleryHeight + 'px')
      self.find('.navigator-item__card-wrapper').css('height', 'auto')
      let targetHeight = self.find('.navigator-item__card-wrapper').height() - currentGalleryHeight + targetGalleryHeight
      self.find('.navigator-item__card-wrapper').css('height', '100%')
      self.find('.navigator-item__card-wrapper').animate({
        height: targetHeight + 'px',
      }, 450, 'easeInOutQuart')
      self.addModifier('scroller')
      $('.navigator').addClass('navigator--mobile-expanded')
      self.add_expanded_events()
    }
  }

  self.add_expanded_events = function() {
    if ($.mlmi.mobile.isMobile) {
      if (self.hammer == undefined) {
        self.hammer = $.mlmi.navigators.current.hammer
      }
      self.hammer.get('swipe').set({ enable: false })
    }
  }

  self.remove_expanded_events = function() {
    if ($.mlmi.mobile.isMobile) {
      self.off('touchstart', self.touch_started)
      self.off('touchmove', self.touch_moved)
      self.off('touchend', self.touch_ended)
      if (self.hammer != undefined) {
        self.hammer.get('swipe').set({ enable: true })
      }
    }
  }

  self.touch_started = function(e) {
    self.touchY = e.touches[0].pageY;
  }

  self.touch_moved = function(e) {
    let delta = 0
    if (self.touchY != undefined) {
      delta = e.touches[0].pageY - self.touchY
    }
    self.touchY = e.touches[0].pageY
    if (delta > 2) {
      self.hammer.get('swipe').set({ enable: false })
    }
  }

  self.touch_ended = function(e) {
    self.touchY = undefined
  }

  return function() {
    self.find('.navigator-item__read-more').on('click', function() {
      if ($.mlmi.mobile.isMobile) {
        if (self.expanded) {
          self.close_content()
        } else {
          self.expand_content()
        }
      }
    })
    self.data('mobile-card', self)
    return self
  }()
}
